import React, { Component } from "react";

class ContactThree extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rnName: "",
      rnEmail: "",
      rnSubject: "",
      rnMessage: "",
      status: false,
    };
  }
  SubmitHandler = (e) => {
    e.preventDefault();
    this.setState({
      status: true,
      rnName: "",
      rnEmail: "",
      rnSubject: "",
      rnMessage: "",
    });
    setTimeout(() => {
      this.setState({
        status: false,
      });
    }, 4000);
  };
  render() {
    return (
      <div className="contact-form--1">
        <div className="container">
          <div className="row row--35 align-items-start">
            <div className="col-lg-6 order-2 order-lg-1">
              <div className="section-title text-left mb--50">
                <h2 className="title">{this.props.contactTitle}</h2>
                <p className="description">
                  {" "}
                  Let's get in <b>touch.</b> Connect with us via{" "}
                  <a href="tel:+9174609-88541">74609-88541</a> or email:
                  <a href="mailto:connect@digilabltd.com">
                    connect<span style={{ fontFamily: "Quicksand" }}>@</span>
                    digilabltd.com
                  </a>{" "}
                </p>
              </div>
              <div className="form-wrapper">
                <form
                  onSubmit={this.SubmitHandler}
                  style={{ fontFamily: "QuickSand" }}
                >
                  <label htmlFor="item01">
                    <input
                      type="text"
                      name="name"
                      id="item01"
                      value={this.state.rnName}
                      onChange={(e) => {
                        this.setState({ rnName: e.target.value });
                      }}
                      required
                      placeholder="Your Name *"
                      style={{ fontFamily: "Virgo 01" }}
                    />
                  </label>

                  <label htmlFor="item02">
                    <input
                      type="email"
                      name="email"
                      id="item02"
                      required
                      value={this.state.rnEmail}
                      onChange={(e) => {
                        this.setState({ rnEmail: e.target.value });
                      }}
                      placeholder="Your email *"
                      style={{ fontFamily: "QuickSand" }}
                    />
                  </label>

                  <label htmlFor="item03">
                    <input
                      type="text"
                      name="subject"
                      id="item03"
                      value={this.state.rnSubject}
                      onChange={(e) => {
                        this.setState({ rnSubject: e.target.value });
                      }}
                      required
                      placeholder="Write a Subject"
                      style={{ fontFamily: "QuickSand" }}
                    />
                  </label>
                  <label htmlFor="item04">
                    <textarea
                      type="text"
                      id="item04"
                      name="message"
                      value={this.state.rnMessage}
                      onChange={(e) => {
                        this.setState({ rnMessage: e.target.value });
                      }}
                      required
                      placeholder="Your Message"
                      style={{ fontFamily: "QuickSand" }}
                    />
                  </label>
                  {this.state.status ? (
                    <p style={{ color: "#009FFD" }}>Submitted Successfully.</p>
                  ) : (
                    <button
                      className="rn-button-style--2 btn-solid"
                      type="submit"
                      value="submit"
                      name="submit"
                      id="mc-embedded-subscribe"
                      style={{ fontFamily: "QuickSand" }}
                    >
                      Submit
                    </button>
                  )}
                </form>
              </div>
            </div>
            <div className="col-lg-6 order-1 order-lg-2">
              <div className="thumbnail mb_md--30 mb_sm--30">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m10!1m8!1m3!1d889.4629071522623!2d80.93099935660393!3d26.908203537818896!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1610963103905!5m2!1sen!2sin"
                  // width="500"
                  // height="500"
                  frameborder="0"
                  // style="border:0;"
                  allowfullscreen=""
                  aria-hidden="false"
                  tabindex="0"
                  className="map"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default ContactThree;
